import React, { FC } from 'react';
import { Box, Container, Flex } from '@radix-ui/themes';
import NavbarLinksList from '../NavbarLinksList/NavbarLinksList';
import './Navbar.css';
import logo from '../../assets/logos/logo.webp';

interface NavbarProps { }

const Navbar: FC<NavbarProps> = () => (
  <Box style={{ position: 'sticky', top: '10px', zIndex: 100, maxWidth: '1200px', margin: '10px auto', padding: '0 10px' }}>
    <Box py="3" px="4" className="NavbarWrapper" style={{ background: "#10ddc270", borderRadius: "12px" }}>
      <Container size="4">
        <Flex align="center" justify="between" gap="4">
          <Box>
            <img src={logo} alt="logo" style={{ width: "80px" }} />
          </Box>

          <Flex gap="6" align="center" style={{ flex: 1, justifyContent: 'center' }} display={{ initial: 'none', lg: 'flex' }}>
          </Flex>

          <Box>
            <NavbarLinksList />
          </Box>
        </Flex>
      </Container>
    </Box>
  </Box>
);

export default Navbar;
